<app-stack-layout>
    <h1>Onboarding</h1>
    <p style="color: grey; margin-top: 10px">
        <b>Welcome to our onboarding journey!</b>
        Below, you'll find the key requirements we gathered from you and the goals we set together to ensure a smooth, transparent, and efficient onboarding process.
    </p>
    <app-empty class="fullsize mt-lg" *ngIf="!isLoading && goals.length === 0">
        <app-stack-layout class="text-center">
            <h2>No results found</h2>
            <p class="mt-sm">We didn't find any onboarding goals.</p>
        </app-stack-layout>
    </app-empty>

    <div class="mt-lg" *ngIf="goals.length > 0">

        <!-- General Requirements Box -->
        <div class="general-requirements-box">
            <h2>General requirements</h2>
            <p *ngIf="goals.length > 0 && goals[0].onboarding_requirements"
                style="white-space: pre-line;">
                {{ goals[0].onboarding_requirements }}
            </p>
            <p *ngIf="goals.length > 0 && !goals[0].onboarding_requirements">No general requirements specified.</p>
        </div>

        <h2>Goals</h2>
        <table>
            <thead>
            <tr>
                <th (click)="sortGoals('rollout_step')">
                    Step
                    <span *ngIf="sortColumn === 'rollout_step'">
    {{ sortDirection === 'asc' ? '▲' : '▼' }}
  </span>
                </th>

                <th (click)="sortGoals('title')">
                    Title
                    <span *ngIf="sortColumn === 'title'">
    {{ sortDirection === 'asc' ? '▲' : '▼' }}
  </span>
                </th>

                <th (click)="sortGoals('description')">
                    Description
                    <span *ngIf="sortColumn === 'description'">
    {{ sortDirection === 'asc' ? '▲' : '▼' }}
  </span>
                </th>

                <th (click)="sortGoals('updated_at')">
                    Last Updated
                    <span *ngIf="sortColumn === 'updated_at'">
    {{ sortDirection === 'asc' ? '▲' : '▼' }}
  </span>
                </th>

                <th (click)="sortGoals('checkin_date')">
                    Check-in date
                    <span *ngIf="sortColumn === 'checkin_date'">
    {{ sortDirection === 'asc' ? '▲' : '▼' }}
  </span>
                </th>

                <th>Guide</th>
                <th>Meeting Link</th>

                <th (click)="sortGoals('status')">
                    Status
                    <span *ngIf="sortColumn === 'status'">
    {{ sortDirection === 'asc' ? '▲' : '▼' }}
  </span>
                </th>
            </tr>
            </thead>

            <tbody>
            <tr *ngFor="let goal of goals; let i = index; trackBy: trackById">
                <td>{{ goal.rollout_step }}</td>
                <td>{{ goal.title }}</td>
                <td>{{ goal.description }}</td>
                <td>
                    {{ goal.updated_at | date: 'MMM d, y' }}
                </td>

                <td>
                    {{ goal.checkin_date | date: 'MMM d, y' }}
                </td>

                <td>
                    <a *ngIf="goal.guide_link" [href]="goal.guide_link" target="_blank">Guide</a>
                </td>
                <td>
                    <a *ngIf="goal.dataedo_call" [href]="goal.dataedo_call" target="_blank">Meeting Link</a>
                </td>
                <td class="status-td">
                    <div class="tooltip-wrapper status-display">
                        <div class="status-pill">
                            <span class="status-dot" [ngStyle]="{ backgroundColor: getStatusDotColor(goal.status) }"></span>
                            {{ getStatusLabel(goal.status) }}
                            <span class="arrow-down">&#9662;</span>
                        </div>
                        <div class="tooltip">
                            {{ goal.status_changed_at ? ('Changed on ' + (goal.status_changed_at | date: 'MMM d, y, HH:mm')) : 'No change history' }}
                        </div>
                    </div>
                </td>



            </tr>
            </tbody>
        </table>
    </div>

    <app-spinner class="fullsize" *ngIf="isLoading"></app-spinner>
</app-stack-layout>
